/* global swal, moment */
import tableHeaders from './tableHeaders';
import modalTemplate from 'modals/marketplace/template.html';
import modalController from 'modals/marketplace/controller';

import './style.less';
import { chunk, get } from 'lodash';

//TODO: Calendar view needs to be added
export default function($q, $log, $uibModal, $filter, $stateParams, ProfileClass) {
  'ngInject';

  $log.debug('Events Component Activated');
  const vm = this;
  vm.$onChanges = activate;

  vm.pageTitle = vm.pageTitle || 'Events';
  vm.tableHeaders = tableHeaders;
  vm.dataCollection = [];

  const { company_id } = ProfileClass;
  const removeOwnEvents = get(ProfileClass, 'profileComplete.company.preferences.read_only.user.removeOwnEvents');

  vm.openEvent = (event, location) => {
    $uibModal
      .open({
        template: modalTemplate,
        controller: modalController(event, location),
        size: 'lg',
        backdrop: true
      })
      .result.catch(error => {
        if (error === 'cancel' || error === 'backdrop click') return;
        $log.error(error);
      });
  };

  function tableClean(events) {
    return events.map(event => {
      const { name, course_name, passes, price, priceText, subject } = event || {};

      event.name = name || subject || course_name;

      if (passes && passes.length) {
        event.priceText = `Included in ${passes.map(({ productName }) => productName).join(', ')}`;
      } else {
        event.priceText = priceText || $filter('currency')(price || 0);
      }

      return event;
    });
  }

  function activate() {
    try {
      $log.debug('Events Component Updated');
      vm.loaded = false;

      vm.pagination = {
        pageSize: vm.pageSize || 10,
        page: $stateParams.page || 1,
        showPage: 0,
        setPage: pageNo => {
          vm.pagination.page = pageNo;
          vm.pagination.showPage = pageNo - 1;
        }
      };

      if (!vm.events) return;

      tableClean(vm.events);

      if (removeOwnEvents) {
        vm.events = vm.events.filter(({company_id: course_company_id, vendor_id}) => course_company_id != company_id && vendor_id != company_id);
      }

      vm.pages = chunk(vm.events, vm.pagination.pageSize);

      vm.loaded = true;
    } catch (e) {
      vm.loaded = true;
      vm.error = true;
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cpeCatalog/table/controller.js